<template lang="pug">
    div
        span(style="padding: 10px") gt
        InputNumber(:value="value.gt" size="small" @on-change="onGtChange")
        span(style="padding: 10px") lt
        InputNumber(:value="value.lt" size="small" @on-change="onLtChange")
</template>
<script>
export default {
    props: {
        value: {
            type: Object,
            default: function() {
                return { gt: null, lt: null };
            }
        },
        formItem: {},
        formData: {}
    },
    methods: {
        onLtChange(val) {
            let rangeValue = { gt: this.value.gt, lt: val };
            this.$emit("input", rangeValue);
            // this.formItem.watchField(rangeValue, this.formData);
        },
        onGtChange(val) {
            let rangeValue = { gt: val, lt: this.value.lt };
            this.$emit("input", rangeValue);
            // this.formItem.watchField(rangeValue, this.formData);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/Range.vue